import {
  ExamCenterProctorDetailsByPermission,
  ExamCenterProctorDetailsHeader,
} from '@exam-center/exam-center-proctor-details';
import { useParams } from '@exam-center/router';
import { Flex } from '@shared/components';

export default function ProctorDetailsPage() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-proctors/proctors/:proctorId');

  return (
    <>
      <ExamCenterProctorDetailsHeader examCenterCode={examCenterCode} />
      <Flex
        sx={(theme) => ({ flexDirection: 'column', p: theme.spacing(6), gap: theme.spacing(6) })}
      >
        <ExamCenterProctorDetailsByPermission />
      </Flex>
    </>
  );
}
